module.exports = __webpack_public_path__ + "img/vahid_ebrahimi.8c22814.jpg";